import React from 'react';

import { Link } from 'react-router-dom';
import withSizes from 'react-sizes';

const mapSizesToProps = ({ width }) => ({
  winW: width
})

class Slider extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentPosision: 0,
      wholeWidth: this.props.films.length * 712 + 80
    }
    this.openTrailer = this.openTrailer.bind(this)
    this.incrementPosition = this.incrementPosition.bind(this)
    this.decrementPosition = this.decrementPosition.bind(this)
    this.getFilmPosterUrl = this.getFilmPosterUrl.bind(this)
  }
  openTrailer(filmId) {
    this.props.openTrailer(filmId)
  }
  incrementPosition() {
    this.setState(prevState => {
      return {
        currentPosision: prevState.currentPosision + 712 <= (this.state.wholeWidth - this.props.winW) ? prevState.currentPosision + 712 : (this.state.wholeWidth - this.props.winW)
      }
    })
  }
  decrementPosition() {
    this.setState(prevState => {
      return {
        currentPosision: prevState.currentPosision - 712 >= 0 ? prevState.currentPosision - 712 : 0
      }
    })
  }

  getFilmPosterUrl(film) {
    if (this.isPosterExist(film)) {
      return film.mobPoster
    }

    return '/img/logo/logo.svg'
  }

  isPosterExist(film) {
    if (film.mobPoster)
      return true
    return false
  }

  render() {
    return (
      <div className="mp__slider">
        <div className="mp__slides__wrapper" style={{ marginLeft: this.state.currentPosision * (-1) + "px" }}>
          {this.props.films.map(film =>
            <Link to={"/movie/" + film.Id} key={film.Id} className={"mp__slide" + (this.isPosterExist(film) ? "" : " mp__slide__mock_bg")} style={{ backgroundImage: 'url(' + this.getFilmPosterUrl(film) + ')' }}>
              <div className={"mp__slide__mask" + (this.isPosterExist(film) ? " mp__slide__mask__bg" : " mmp__slide__mask__mock_bg")}>
                {film.Rating && <div className="age_restriction">{film.Rating}</div>}
                <div className="mp__slide__content">
                  {film.TrailerUrl && <img src="/img/ic_play.svg" alt="Трейлер" className="mp__slide__trailer" onClick={() => { this.openTrailer(film.Id) }} />}
                  <div className="mp__slide__bottom">
                    <p className="mp__slide__title">{film.Name}</p>
                    <span className="mp__slide__button">Квитки</span>
                  </div>
                  {film.mov_rate.imdb && <p className="mp__slide__rating"><img src="/img/ic_star.svg" alt="" />{film.mov_rate.imdb} IMDB</p>}
                  {!film.mov_rate.imdb && <p className="mp__slide__rating">&nbsp;</p>}
                </div>
              </div>
            </Link>
          )}
        </div>
        {this.state.currentPosision < this.state.wholeWidth - this.props.winW && <div className="mp__slider__button mp__slider__button__next" onClick={() => this.incrementPosition()}></div>}
        {this.state.currentPosision > 0 && <div className="mp__slider__button mp__slider__button__prev" onClick={() => this.decrementPosition()}></div>}
      </div>
    )
  }
}

export default withSizes(mapSizesToProps)(Slider)


// WEBPACK FOOTER //
// ./src/components/pages/HomePage/slider.jsx